import {
  GET_DASHBOARD_JOB_INFO_CUSTOM,
  GET_DASHBOARD_JOB_INFO_CUSTOM_FAILURE,
  GET_DASHBOARD_JOB_INFO_CUSTOM_SUCCESS, //new dashboard api calls latest jan 26
  GET_DASHBOARD_JOB_INFO_TODAY,
  GET_DASHBOARD_JOB_INFO_TODAY_FAILURE,
  GET_DASHBOARD_JOB_INFO_TODAY_SUCCESS,
  GET_DASHBOARD_ATTENDANCE,
  GET_DASHBOARD_ATTENDANCE_FAILURE,
  GET_DASHBOARD_ATTENDANCE_SUCCESS,
  GET_DASHBOARD_INVOICE,
  GET_DASHBOARD_INVOICE_SUCCESS,
  GET_DASHBOARD_INVOICE_FAILURE,
  GET_DASHBOARD_PERFORMERS,
  GET_DASHBOARD_PERFORMERS_SUCCESS,
  GET_DASHBOARD_PERFORMERS_FAILURE,
  GET_DASHBOARD_PROJECT_COUNT,
  GET_DASHBOARD_PROJECT_COUNT_FAILURE,
  GET_DASHBOARD_PROJECT_COUNT_SUCCESS,
  GET_DASHBOARD_REVENUE_INFO,
  GET_DASHBOARD_TIMESHEET_COUNT,
  GET_DASHBOARD_TIMESHEET_COUNT_FAILURE,
  GET_DASHBOARD_TIMESHEET_COUNT_SUCCESS,
  GET_DASHBOARD_REVENUE_INFO_SUCCESS,
  GET_DASHBOARD_REVENUE_INFO_FAILURE,
  GET_DASHBOARD_CUSTOMER,
  GET_DASHBOARD_CUSTOMER_SUCCESS,
  GET_DASHBOARD_CUSTOMER_FAILURE,
  GET_DASHBOARD_ESTIMATION,
  GET_DASHBOARD_ESTIMATION_SUCCESS,
  GET_DASHBOARD_ESTIMATION_FAILURE,
  GET_DASHBOARD_ORG_SALES,
  GET_DASHBOARD_ORG_SALES_SUCCESS,
  GET_DASHBOARD_ORG_SALES_FAILURE,
} from "../../modules/constants";

//new dashboard api calls latest jan 26
export const handleDashboardJobInfoToday = (state, action) => {
  return {
    ...state,
    jobsInfoTodayIsloading: true,
  };
};
export const handleDashboardJobInfoTodaySuccess = (state, action) => {
  return {
    ...state,
    jobsInfoToday: action.payload,
    jobsInfoTodayIsloading: false,
  };
};
export const handleDashboardJobInfoTodayFailure = (state, action) => {
  return {
    ...state,
    jobsInfoTodayIsloading: false,
  };
};

// Custom day handlers
export const handleDashboardJobInfoCustom = (state, action) => {
  return {
    ...state,
    jobsInfoCustomIsloading: true,
  };
};
export const handleDashboardJobInfoCustomSuccess = (state, action) => {
  return {
    ...state,
    jobsInfoCustomIsloading: false,
    jobsInfoCustom: action.payload, // Payload is already the actual data
  };
};
export const handleDashboardJobInfoCustomFailure = (state, action) => {
  return {
    ...state,
    jobsInfoCustomIsloading: false,
  };
};

//implelement attendance data reducer
export const handleDashboardAttendance = (state, action) => {
  return {
    ...state,
    attendanceIsLoading: true,
  };
};
export const handleDashboardAttendanceSuccess = (state, action) => {
  return {
    ...state,
    attendanceIsLoading: false,
    attendanceData: action.payload,
  };
};
export const handleDashboardAttendanceFailure = (state, action) => {
  return {
    ...state,
    attendanceIsLoading: false,
  };
};

// Invoice handlers
export const handleDashboardInvoice = (state, action) => {
  return {
    ...state,
    invoiceIsLoading: true,
  };
};
export const handleDashboardInvoiceSuccess = (state, action) => {
  return {
    ...state,
    invoiceIsLoading: false,
    invoiceData: action.payload,
  };
};
export const handleDashboardInvoiceFailure = (state, action) => {
  return {
    ...state,
    invoiceIsLoading: false,
  };
};

// Performers handlers
export const handleDashboardPerformers = (state, action) => {
  return {
    ...state,
    performersIsLoading: true,
  };
};
export const handleDashboardPerformersSuccess = (state, action) => {
  return {
    ...state,
    performersIsLoading: false,
    topPerformers: action.payload,
  };
};
export const handleDashboardPerformersFailure = (state, action) => {
  return {
    ...state,
    performersIsLoading: false,
  };
};

// Revenue handlers
export const handleDashboardRevenue = (state, action) => {
  return {
    ...state,
    revenueIsLoading: true,
  };
};
export const handleDashboardRevenueSuccess = (state, action) => {
  const payload = action.payload;
  return {
    ...state,
    revenueIsLoading: false,
    lastYearRevenue: payload.last_year || null,
    thisYearRevenue: payload.this_year || null,
    currentMonthIndex: payload.current_month_index !== undefined ? payload.current_month_index : null,
  };
};
export const handleDashboardRevenueFailure = (state, action) => {
  return {
    ...state,
    revenueIsLoading: false,
  };
};

// Customer handlers
export const handleDashboardCustomer = (state, action) => {
  return {
    ...state,
    customerPerformanceIsLoading: true,
  };
};
export const handleDashboardCustomerSuccess = (state, action) => {
  return {
    ...state,
    customerPerformanceIsLoading: false,
    customerPerformanceData: action.payload,
  };
};
export const handleDashboardCustomerFailure = (state, action) => {
  return {
    ...state,
    customerPerformanceIsLoading: false,
  };
};

// Estimation handlers
export const handleDashboardEstimation = (state, action) => {
  return {
    ...state,
    estimationIsLoading: true,
  };
};
export const handleDashboardEstimationSuccess = (state, action) => {
  return {
    ...state,
    estimationIsLoading: false,
    estimationData: action.payload,
  };
};
export const handleDashboardEstimationFailure = (state, action) => {
  return {
    ...state,
    estimationIsLoading: false,
  };
};

// Organization Sales handlers
export const handleDashboardOrganizationSales = (state, action) => {
  return {
    ...state,
    organizationSalesIsLoading: true,
  };
};
export const handleDashboardOrganizationSalesSuccess = (state, action) => {
  return {
    ...state,
    organizationSalesIsLoading: false,
    organizationSalesData: action.payload,
  };
};
export const handleDashboardOrganizationSalesFailure = (state, action) => {
  return {
    ...state,
    organizationSalesIsLoading: false,
  };
};

// Project Count handlers
export const handleDashboardProjectCount = (state, action) => {
  return {
    ...state,
    projectCountIsLoading: true,
  };
};
export const handleDashboardProjectCountSuccess = (state, action) => {
  return {
    ...state,
    projectCountIsLoading: false,
    projectCountData: action.payload,
  };
};
export const handleDashboardProjectCountFailure = (state, action) => {
  return {
    ...state,
    projectCountIsLoading: false,
  };
};

// Timesheet Count handlers
export const handleDashboardTimesheetCount = (state, action) => {
  return {
    ...state,
    timesheetCountIsLoading: true,
  };
};
export const handleDashboardTimesheetCountSuccess = (state, action) => {
  return {
    ...state,
    timesheetCountIsLoading: false,
    timesheetCountData: action.payload,
  };
};
export const handleDashboardTimesheetCountFailure = (state, action) => {
  return {
    ...state,
    timesheetCountIsLoading: false,
  };
};

const ACTION_HANDLERS = {
  //new dashboard api calls latest jan 26
  [GET_DASHBOARD_JOB_INFO_TODAY]: handleDashboardJobInfoToday,
  [GET_DASHBOARD_JOB_INFO_TODAY_SUCCESS]: handleDashboardJobInfoTodaySuccess,
  [GET_DASHBOARD_JOB_INFO_TODAY_FAILURE]: handleDashboardJobInfoTodayFailure,
  // Custom day handlers
  [GET_DASHBOARD_JOB_INFO_CUSTOM]: handleDashboardJobInfoCustom,
  [GET_DASHBOARD_JOB_INFO_CUSTOM_SUCCESS]: handleDashboardJobInfoCustomSuccess,
  [GET_DASHBOARD_JOB_INFO_CUSTOM_FAILURE]: handleDashboardJobInfoCustomFailure,
  [GET_DASHBOARD_ATTENDANCE]: handleDashboardAttendance,
  [GET_DASHBOARD_ATTENDANCE_SUCCESS]: handleDashboardAttendanceSuccess,
  [GET_DASHBOARD_ATTENDANCE_FAILURE]: handleDashboardAttendanceFailure,
  [GET_DASHBOARD_INVOICE]: handleDashboardInvoice,
  [GET_DASHBOARD_INVOICE_SUCCESS]: handleDashboardInvoiceSuccess,
  [GET_DASHBOARD_INVOICE_FAILURE]: handleDashboardInvoiceFailure,
  [GET_DASHBOARD_PERFORMERS]: handleDashboardPerformers,
  [GET_DASHBOARD_PERFORMERS_SUCCESS]: handleDashboardPerformersSuccess,
  [GET_DASHBOARD_PERFORMERS_FAILURE]: handleDashboardPerformersFailure,
  [GET_DASHBOARD_REVENUE_INFO]: handleDashboardRevenue,
  [GET_DASHBOARD_REVENUE_INFO_SUCCESS]: handleDashboardRevenueSuccess,
  [GET_DASHBOARD_REVENUE_INFO_FAILURE]: handleDashboardRevenueFailure,
  [GET_DASHBOARD_CUSTOMER]: handleDashboardCustomer,
  [GET_DASHBOARD_CUSTOMER_SUCCESS]: handleDashboardCustomerSuccess,
  [GET_DASHBOARD_CUSTOMER_FAILURE]: handleDashboardCustomerFailure,
  [GET_DASHBOARD_ESTIMATION]: handleDashboardEstimation,
  [GET_DASHBOARD_ESTIMATION_SUCCESS]: handleDashboardEstimationSuccess,
  [GET_DASHBOARD_ESTIMATION_FAILURE]: handleDashboardEstimationFailure,
  [GET_DASHBOARD_ORG_SALES]: handleDashboardOrganizationSales,
  [GET_DASHBOARD_ORG_SALES_SUCCESS]: handleDashboardOrganizationSalesSuccess,
  [GET_DASHBOARD_ORG_SALES_FAILURE]: handleDashboardOrganizationSalesFailure,
  [GET_DASHBOARD_PROJECT_COUNT]: handleDashboardProjectCount,
  [GET_DASHBOARD_PROJECT_COUNT_SUCCESS]: handleDashboardProjectCountSuccess,
  [GET_DASHBOARD_PROJECT_COUNT_FAILURE]: handleDashboardProjectCountFailure,
  [GET_DASHBOARD_TIMESHEET_COUNT]: handleDashboardTimesheetCount,
  [GET_DASHBOARD_TIMESHEET_COUNT_SUCCESS]: handleDashboardTimesheetCountSuccess,
  [GET_DASHBOARD_TIMESHEET_COUNT_FAILURE]: handleDashboardTimesheetCountFailure,
};

const initialState = {
  //new dashboard api calls latest jan 26
  jobsInfoTodayIsloading: false,
  jobsInfoToday: null,
  // Custom day state
  jobsInfoCustomIsloading: false,
  jobsInfoCustom: null,
  attendanceIsLoading: false,
  attendanceData: null,
  invoiceIsLoading: false,
  invoiceData: null,
  performersIsLoading: false,
  topPerformers: null,
  revenueIsLoading: false,
  lastYearRevenue: null,
  thisYearRevenue: null,
  currentMonthIndex: null,
  customerPerformanceIsLoading: false,
  customerPerformanceData: null,
  estimationIsLoading: false,
  estimationData: null,
  organizationSalesIsLoading: false,
  organizationSalesData: null,
  projectCountIsLoading: false,
  projectCountData: null,
  timesheetCountIsLoading: false,
  timesheetCountData: null,
};

export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
